import { ulid } from "ulid";
// TODO: Rename to `newULID`
export const newId = () => ulid();
/**
 * Generates a new random ULID.
 */
export function newULID() {
    return ulid();
}
const typePattern = /[0-9A-Zaz]+/;
const ulidPattern = /[0-9A-Z]{26}/;
/**
 * Checks if a string looks like a ULID.
 */
export function isLikeULID(value) {
    return typeof value === "string" && ulidPattern.test(value);
}
/**
 * Checks if a string looks like a global ID (type + ULID)
 */
export function isLikeGlobalId(value) {
    return (typeof value === "string" &&
        typePattern.test(value.slice(0, -26)) &&
        ulidPattern.test(value.slice(-26)));
}
//# sourceMappingURL=id.js.map